import Calendar from "PFComponents/calendar/calendar";
import { Select } from "PFComponents/select";
import { InputFieldSet } from "PFComponents/text/input_field_set";
import { Option } from "PFTypes/options";
import { Control, Controller } from "react-hook-form";

import css from "./expiry_date_change_fields.module.scss";
import { ReasonsForm } from "./expiry_date_change_fields.types";

type ExpiryDateChangeFieldsProps = {
  control: Control<ReasonsForm>;
  reasonLabel: string;
  minDate: string;
  isReasonSelectorEnabled: boolean;
  isOtherReason: boolean;
  dropdownOptions: Option<string>[];
};

export const ExpiryDateChangeFields = ({
  control,
  reasonLabel,
  minDate,
  isReasonSelectorEnabled,
  isOtherReason,
  dropdownOptions
}: ExpiryDateChangeFieldsProps) => (
  <>
    {isReasonSelectorEnabled && (
      <>
        <Controller
          control={control}
          name="reason"
          render={({ field: { onChange, value } }) => (
            <Select
              label={reasonLabel}
              required
              value={value}
              options={dropdownOptions}
              onChange={(option) => onChange((option as Option<string>).original)}
            />
          )}
        />
        {isOtherReason && (
          <Controller
            control={control}
            name="otherReason"
            render={({ field: { onChange, value } }) => (
              <InputFieldSet
                value={value}
                inputType="textarea"
                maxLength={200}
                required={true}
                qaId="otherReasonInput"
                onChange={onChange}
                className={css.otherInput}
              />
            )}
          />
        )}
      </>
    )}
    <Controller
      control={control}
      rules={{ required: true }}
      name="date"
      render={({ field: { onChange, value } }) => (
        <Calendar
          selectedDate={value}
          handleChange={onChange}
          minDate={minDate}
          fixedWidth={false}
          style={{ padding: "var(--spacingXl) 0" }}
        />
      )}
    />
  </>
);
